import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Paragraph,
  List,
  Heading,
} from 'ckeditor5';

const MultiLanguageCKEditor = ({
  name,
  currentLanguage = 'en',
  referenceValue = '',
  ...props
}) => {
  const { t } = useTranslation();
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    const newValue = {
      ...field.value,
      [currentLanguage]: data,
    };
    setValue(newValue);
  };

  const getEditorValue = () => {
    return field.value?.[currentLanguage] || '';
  };

  return (
    <div className="multilang-ckeditor-container">
      <div className="formik-custom-field act-inputs-new">
        <label
          className={props.requiredStar ? 'required-stars' : ''}
          htmlFor={props.id || props.name}
        >
          {props.labelText}
        </label>
        <CKEditor
          editor={ClassicEditor}
          config={{
            plugins: [Essentials, Bold, Italic, List, Heading, Paragraph],
            ...props.config,
          }}
          data={getEditorValue()}
          onBlur={handleEditorChange}
          disabled={props.disabled}
        />
        {meta.touched && meta.error && (
          <div className="invalid-feedback">
            {typeof meta.error === 'string'
              ? meta.error
              : meta.error[currentLanguage] || Object.values(meta.error)[0]}
          </div>
        )}
      </div>

      {referenceValue && currentLanguage !== 'en' && (
        <div className="reference-text">
          <small className="text-muted">
            <strong>{t('common.reference')}:</strong>
            <div
              className="reference-html-content"
              dangerouslySetInnerHTML={{ __html: referenceValue }}
              style={{
                marginTop: '5px',
                padding: '8px',
                backgroundColor: '#f8f9fa',
                borderRadius: '4px',
                fontSize: '0.9em',
              }}
            />
          </small>
        </div>
      )}
    </div>
  );
};

export default MultiLanguageCKEditor;
